import { defineComponent as _defineComponent } from 'vue'
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySwitchConfirmDialog',
  props: {
    value: { type: Boolean },
    targetCompanyName: null
  },
  emits: ["input", "cancel", "confirm"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'cancel'): void;
  (e: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  switchConfirmTitle: '表示するテナントを「{companyName}」に変更しますか？',
  switchConfirmDescriptionPrefix: '「切り替える」をクリックすると、',
  switchConfirmDescriptionSuffix: 'の情報に切り替わります。',
  switchButton: '切り替える',
});





const handleInput = (value: boolean) => {
  emit('input', value);
};

const handleCancel = () => {
  emit('cancel');
};

const handleConfirm = () => {
  emit('confirm');
};

return { __sfc: true,$t, m, emit, handleInput, handleCancel, handleConfirm, sharedMessages }
}

})